export const sliceFileName = (fileName: string, length = 32) => {
  const ext = fileName.slice(fileName.lastIndexOf('.') + 1).toLocaleLowerCase();
  if (fileName.length > length) {
    return `${fileName.slice(0, length - 1 - ext.length)}.${ext}`;
  }
  return fileName;
};

export const getFileNameAndExt = (file: File | string, length = 32) => {
  const f = typeof file === 'string' ? file : file.name;
  const name = sliceFileName(f, length);
  const index = name.lastIndexOf('.');
  const fileName = index === -1 ? name : name.substring(0, index);
  const ext = index === -1 ? '' : name.slice(index + 1).toLocaleLowerCase();
  return { fileName, ext };
};

export const getFileNameFromUrl = (url: string) => {
  const path = url.split('?')[0];
  const index = path.lastIndexOf('/');
  if (index === -1) return url;
  return url.substring(index + 1);
};

export function getAssetsPrefix() {
  return (window as any).__EASYTWIN_CONFIGS__.assetsPrefix;
}

export function parseFileSize(size: number) {
  return size / 1024 < 1024
    ? `${(size / 1024).toFixed(2)}KB`
    : `${(size / 1024 / 1024).toFixed(2)}MB`;
}

export const isFileAccepted = (file: File, accept: string) => {
  const acceptArray = accept.split(',');
  const fileName = file.name.toLowerCase();
  const mimeType = file.type.toLowerCase();
  const baseMimeType = mimeType.replace(/\/.*$/, '');

  return acceptArray.some((a) => {
    const accType = a.trim();
    // accType = "*/*"|"*"
    if (/^\*(\/\*)?$/.test(accType)) {
      return true;
    }
    // accType = .xxx
    if (accType.charAt(0) === '.') {
      return fileName.endsWith(accType);
    }
    // accType = MIME ,e.g. image/*, video/*
    if (/\/\*$/.test(accType)) {
      return baseMimeType === accType.replace(/\/.*$/, '');
    }

    // accType = MIME ,e.g. image/jpeg, audio/ogg
    if (mimeType === accType) {
      return true;
    }

    if (/^\w+$/.test(accType)) {
      console.warn(false, `Upload takes an invalidate 'accept' type '${accType}'.Skip for check.`);
      return true;
    }
    return false;
  });
};

// FeatModelExt和FeatImageExt已经迁移到了runtime，这里保留一份是为了旧组件能运行在新版本引擎上
export const FeatModelExt = ['glb'];
export const FeatImageExt = [
  'jpg',
  'jpeg',
  'png',
  'pjp',
  'pjpeg',
  'webp',
  'gif',
  'svg',
  'ico',
  'tif',
  'tiff',
  'bmp',
];
